import { FormattedMessage } from 'react-intl';
import { DefaultErrorPage, LoadingAnimation } from '@odmonorepo/core-components';
import { unifiedApi} from 'merchant-api';
import { useQuery } from '@tanstack/react-query';

export const CustomLinkRequired = () => {
  const { data: user, isPending } = useQuery({ ...unifiedApi.queryOptions('get', '/client/user/v1/profile'), retry: false, throwOnError: false});

  if (isPending) return <div className='mx-auto'><LoadingAnimation /></div>;

  const email = user?.email;

  return <DefaultErrorPage
    title={<FormattedMessage id="customError.customLinkRequired.title" />}
    message={
      <>
        <div className="mb-4">
          {email ? (
            <FormattedMessage id="customError.customLinkRequired.message" values={{ email: <strong>{email}</strong> }} />
          ) : (
            <FormattedMessage id="customError.customLinkRequired.messageNoEmail" />
          )}
        </div>
        <div>
          <FormattedMessage id="customError.customLinkRequired.contactMessage" />
        </div>
      </>
    }
    customerServiceCard={false}
    hasHeader
  />;
};

export default CustomLinkRequired;
